import { DataCore } from "./SDKDataCore";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class DataCoreCached extends DataCore {
    constructor() {
        super(...arguments);
        this.tokensCache = new Map();
        this.tokenGroupsCache = new Map();
        this.designSystemSourcesCache = new Map();
        this.themesCache = new Map();
        this.elementPropertyDefinitionsCache = new Map();
        this.elementPropertyValuesCache = new Map();
        this.elementViewsCache = new Map();
        this.componentsCache = new Map();
        this.componentGroupsCache = new Map();
        this.designComponentsCache = new Map();
        this.designComponentGroupsCache = new Map();
    }
    tokens(designSystemId, versionId, filter) {
        var _a, _b;
        return this.cached(this.tokensCache, [designSystemId, versionId, (_a = filter === null || filter === void 0 ? void 0 : filter.brandId) !== null && _a !== void 0 ? _a : "", (_b = filter === null || filter === void 0 ? void 0 : filter.type) !== null && _b !== void 0 ? _b : ""], () => super.tokens(designSystemId, versionId, filter));
    }
    tokenGroups(designSystemId, versionId, filter) {
        var _a, _b;
        return this.cached(this.tokenGroupsCache, [designSystemId, versionId, (_a = filter === null || filter === void 0 ? void 0 : filter.brandId) !== null && _a !== void 0 ? _a : "", (_b = filter === null || filter === void 0 ? void 0 : filter.type) !== null && _b !== void 0 ? _b : ""], () => super.tokenGroups(designSystemId, versionId, filter));
    }
    designSystemSources(designSystemId) {
        return this.cached(this.designSystemSourcesCache, [designSystemId], () => super.designSystemSources(designSystemId));
    }
    themes(designSystemId, versionId) {
        return this.cached(this.themesCache, [designSystemId, versionId], () => super.themes(designSystemId, versionId));
    }
    elementPropertyDefinitions(designSystemId, versionId, type) {
        return this.cached(this.elementPropertyDefinitionsCache, [designSystemId, versionId, type], () => super.elementPropertyDefinitions(designSystemId, versionId, type));
    }
    elementPropertyValues(designSystemId, versionId) {
        return this.cached(this.elementPropertyValuesCache, [designSystemId, versionId], () => super.elementPropertyValues(designSystemId, versionId));
    }
    elementViews(designSystemId, versionId, type) {
        return this.cached(this.elementViewsCache, [designSystemId, versionId, type], () => super.elementViews(designSystemId, versionId, type));
    }
    components(designSystemId, versionId, filter) {
        var _a;
        return this.cached(this.componentsCache, [designSystemId, versionId, (_a = filter === null || filter === void 0 ? void 0 : filter.brandId) !== null && _a !== void 0 ? _a : ""], () => super.components(designSystemId, versionId, filter));
    }
    componentGroups(designSystemId, versionId) {
        return this.cached(this.componentGroupsCache, [designSystemId, versionId], () => super.componentGroups(designSystemId, versionId));
    }
    designComponents(designSystemId, versionId, filter) {
        var _a;
        return this.cached(this.designComponentsCache, [designSystemId, versionId, (_a = filter === null || filter === void 0 ? void 0 : filter.brandId) !== null && _a !== void 0 ? _a : ""], () => super.designComponents(designSystemId, versionId, filter));
    }
    designComponentGroups(designSystemId, versionId, filter) {
        var _a;
        return this.cached(this.designComponentGroupsCache, [designSystemId, versionId, (_a = filter === null || filter === void 0 ? void 0 : filter.brandId) !== null && _a !== void 0 ? _a : ""], () => super.designComponentGroups(designSystemId, versionId, filter));
    }
    cached(cache, keyParts, loader) {
        const key = JSON.stringify(keyParts);
        if (!cache.has(key)) {
            cache.set(key, loader());
        }
        return cache.get(key);
    }
}
